import PatchOps from '@leverege/api-patch-ops'
import { updateApiAccess } from './ProjectActions'

/*
  Usage:
    let updater = ApiAccessUpdater( dispatch, project )
      .set( "a/string/to/a/path", "value 1" )
      .set( "a/string/to/another/path", "value 2" )
      .done();
 */

function ApiAccessUpdater( dispatch, apiAccess, key, value ) {
  
  const patchOps = PatchOps( key, value );

  patchOps.done = function( ) {
    return dispatch( updateApiAccess( apiAccess, patchOps.ops() ) );

  }  

  return patchOps;
}

module.exports = ApiAccessUpdater;
